export const travelTagSearch = `https://search-eschr-demo-kokjqkr3h4rrpfcwbrqzdrdhbu.ap-southeast-1.es.amazonaws.com/test/tags/_search`;
export const travelSuggestions = `https://search-eschr-tyiqhwx3brb5tglcxbocehuvda.eu-west-1.es.amazonaws.com/test/suggestions/_search`;
export const travelSingleItem =`https://search-eschr-demo-kokjqkr3h4rrpfcwbrqzdrdhbu.ap-southeast-1.es.amazonaws.com/test/tags/`;
export const travelImageUpload = `https://vynwt6nfq5.execute-api.eu-west-1.amazonaws.com/demo/upload`;



// WEBPACK FOOTER //
// ./src/travel.config.inc.js